import { useEffect, useState } from "react";
import { getConfig, isConfigLoaded } from "lib/config";
import useSettingState from "~/stores/setting";
import useFeaturesState, { FEATURES } from "~/stores/feature";
import useLicenseState from "~/stores/license";
import { useResolvedMode } from "~/hooks/resolved-mode-hook";

export function CompanyLogo({
  alt = "Logo",
  className,
}: {
  alt?: string;
  className?: string;
}) {
  const isDark = useResolvedMode() === "dark";
  const fallbackSrc = isDark ? "/sensor-online-dark.svg" : "/sensor-online.svg";

  const { getWhiteLabelImage, getGlobalWhiteLabelImage } = useSettingState();
  const { hasFeatureAccess } = useFeaturesState();
  const { isPermittedWhiteLabel } = useLicenseState();

  function resolveLogoSrc(): string {
    if (!isConfigLoaded() || !isPermittedWhiteLabel()) return fallbackSrc;

    const whiteLabelImage = getWhiteLabelImage();
    if (whiteLabelImage && hasFeatureAccess(FEATURES.PER_COMPANY_BRANDING)) {
      return `${getConfig().BASE_URL}/image/${whiteLabelImage}`;
    }

    // Fallback to the Global whitelabel image as isPermittedWhiteLabel() is true
    const globalWhiteLabelImage = getGlobalWhiteLabelImage();
    if (globalWhiteLabelImage) {
      return `${getConfig().BASE_URL}/image/${globalWhiteLabelImage}`;
    }
    return "/so-white-label.png";
  }

  const logoSrc = resolveLogoSrc();
  const [src, setSrc] = useState(logoSrc);

  useEffect(() => {
    setSrc(logoSrc);
  }, [logoSrc]);

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setSrc(fallbackSrc)}
    />
  );
}
